import replaceUrlVersion from './replaceUrlVersion'

export default function overrideScriptsLocationMapFromQuery(scriptsLocationMap, overrideParam) {
  overrideParam.split(',').filter(Boolean).forEach(keyValueString => {
    const pair = keyValueString.split(':')
    const urlOverride = replaceUrlVersion(scriptsLocationMap[pair[0]], pair[1])
    if (urlOverride && scriptsLocationMap[pair[0]] !== urlOverride) {
      scriptsLocationMap[pair[0]] = urlOverride
    }
  })
  return scriptsLocationMap
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/lib/common/overrideScriptsLocationMapFromQuery.js